const styles = {
  pickupDateContainer: {
    width: '100%',
    px: 2,
  },
  select: {
    '& .MuiSelect-select.MuiInputBase-input': {
      pl: 2.5,
    },
    '& svg': {
      width: theme => theme.spacing(3),
      height: theme => theme.spacing(3),
      mr: 1.5,
    },
  },
  alert: {
    '&.MuiAlert-root': {
      mt: 1.5,
    },
  },
}

export default styles
